import { createSelector } from '@reduxjs/toolkit';
import { selectInfrastructure } from 'shared/selectors/jsonQuery';
import { EInfrastructureItem } from '../../../../packages/api-models/common/json_query';

const OPTIONS = [
  { label: 'Автомойка', value: EInfrastructureItem.CarWash },
  { label: 'Автосервис', value: EInfrastructureItem.CarService },
  { label: 'Аптека', value: EInfrastructureItem.Pharmacy },
  { label: 'Ателье', value: EInfrastructureItem.ClothesStudio },
  { label: 'Банкомат', value: EInfrastructureItem.ATM },
  { label: 'Бассейн', value: EInfrastructureItem.Pool },
  { label: 'Буфет', value: EInfrastructureItem.Buffet },
  { label: 'Выставочно-складской комплекс', value: EInfrastructureItem.WarehouseComplex },
  { label: 'Гостиница', value: EInfrastructureItem.Hotel },
  { label: 'Кафе', value: EInfrastructureItem.Cafe },
  { label: 'Кинотеатр', value: EInfrastructureItem.Cinema },
  { label: 'Конференц-зал', value: EInfrastructureItem.ConferenceRoom },
  { label: 'Медицинский центр', value: EInfrastructureItem.MedicalCenter },
  { label: 'Минимаркет', value: EInfrastructureItem.Minimarket },
  { label: 'Нотариальная контора', value: EInfrastructureItem.NotaryOffice },
  { label: 'Отделение банка', value: EInfrastructureItem.Department },
  { label: 'Парк', value: EInfrastructureItem.Park },
  { label: 'Ресторан', value: EInfrastructureItem.Restaurant },
  { label: 'Салон красоты', value: EInfrastructureItem.BeautyShop },
  { label: 'Складские помещения', value: EInfrastructureItem.Warehouse },
  { label: 'Столовая', value: EInfrastructureItem.Canteen },
  { label: 'Супермаркет', value: EInfrastructureItem.Supermarket },
  { label: 'Торговая зона', value: EInfrastructureItem.ShoppingArea },
  { label: 'Фитнес-центр', value: EInfrastructureItem.FitnessCentre },
  { label: 'Фотостудия', value: EInfrastructureItem.Studio },
  { label: 'Центральный ресепшен', value: EInfrastructureItem.CentralReception },
];

export const selectInfrastructureFilter = createSelector(selectInfrastructure, value => ({
  label: 'Инфраструктура',
  options: OPTIONS,
  value: value && value.length > 0 ? value : [null],
}));
